import sliceCreator from '../../index.jsx';
import {UPDATE_DISTRICT} from '../../../constants/index.jsx';
const _updateDistrictAction = sliceCreator('UPDATE_DISTRICT', UPDATE_DISTRICT, 'put');

const { asyncAction: updateDistrictAction, reducer, clearData: clearUpdateDistrictAction } = _updateDistrictAction;

export default reducer;

export {
    updateDistrictAction,
    clearUpdateDistrictAction
}